// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ALL_OVER_PRINTING_DC_REQUEST = 'FETCH_ALL_OVER_PRINTING_DC_REQUEST';
export const FETCH_ALL_OVER_PRINTING_DC_SUCCESS = 'FETCH_ALL_OVER_PRINTING_DC_SUCCESS';
export const FETCH_ALL_OVER_PRINTING_DC_FAILURE = 'FETCH_ALL_OVER_PRINTING_DC_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_ALL_OVER_PRINTING_DC_REQUEST = 'CREATE_ALL_OVER_PRINTING_DC_REQUEST';
export const CREATE_ALL_OVER_PRINTING_DC_SUCCESS = 'CREATE_ALL_OVER_PRINTING_DC_SUCCESS';
export const CREATE_ALL_OVER_PRINTING_DC_FAILURE = 'CREATE_ALL_OVER_PRINTING_DC_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_ALL_OVER_PRINTING_DC = 'CREATE_USER_FORM_ALL_OVER_PRINTING_DC';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_ALL_OVER_PRINTING_DC_REQUEST = 'UPDATE_ALL_OVER_PRINTING_DC_REQUEST';
export const UPDATE_ALL_OVER_PRINTING_DC_SUCCESS = 'UPDATE_ALL_OVER_PRINTING_DC_SUCCESS';
export const UPDATE_ALL_OVER_PRINTING_DC_FAILURE = 'UPDATE_ALL_OVER_PRINTING_DC_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_ALL_OVER_PRINTING_DC_REQUEST = 'FETCH_SINGLE_ALL_OVER_PRINTING_DC_REQUEST';
export const FETCH_SINGLE_ALL_OVER_PRINTING_DC_SUCCESS = 'FETCH_SINGLE_ALL_OVER_PRINTING_DC_SUCCESS';
export const FETCH_SINGLE_ALL_OVER_PRINTING_DC_FAILURE = 'FETCH_SINGLE_ALL_OVER_PRINTING_DC_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_ALL_OVER_PRINTING_DC_REQUEST = 'DELETE_ALL_OVER_PRINTING_DC_REQUEST';
export const DELETE_ALL_OVER_PRINTING_DC_SUCCESS = 'DELETE_ALL_OVER_PRINTING_DC_SUCCESS';
export const DELETE_ALL_OVER_PRINTING_DC_FAILURE = 'DELETE_ALL_OVER_PRINTING_DC_FAILURE';

// USERFORM RESET

export const ALL_OVER_PRINTING_DC_USERFORM_RESET = 'ALL_OVER_PRINTING_DC_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_ALL_OVER_PRINTING_DC_DETAILS = 'NAVIGATE_ALL_OVER_PRINTING_DC_DETAILS';
// navigate to company component
export const NAVIGATE_ALL_OVER_PRINTING_DC = 'NAVIGATE_ALL_OVER_PRINTING_DC';
export const ALL_OVER_PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'ALL_OVER_PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB';
export const ALL_OVER_PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'ALL_OVER_PRINTING_DC_USERFORM_NAVIGATE_TO_DETAIL_REVERSE';

export const FETCH_ALL_OVER_PRINTING_DC_STYLE_REQUEST = 'FETCH_ALL_OVER_PRINTING_DC_STYLE_REQUEST';
export const FETCH_ALL_OVER_PRINTING_DC_STYLE_SUCCESS = 'FETCH_ALL_OVER_PRINTING_DC_STYLE_SUCCESS';
export const FETCH_ALL_OVER_PRINTING_DC_STYLE_FAILURE = 'FETCH_ALL_OVER_PRINTING_DC_STYLE_FAILURE';

// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_ALL_OVER_PRINTING_DC_INVOICE_REQUEST = 'FETCH_ALL_OVER_PRINTING_DC_INVOICE_REQUEST';
export const FETCH_ALL_OVER_PRINTING_DC_INVOICE_SUCCESS = 'FETCH_ALL_OVER_PRINTING_DC_INVOICE_SUCCESS';
export const FETCH_ALL_OVER_PRINTING_DC_INVOICE_FAILURE = 'FETCH_ALL_OVER_PRINTING_DC_INVOICE_FAILURE';

export const RESET_ALL_OVER_PRINTING_DC_INVOICE = 'RESET_ALL_OVER_PRINTING_DC_INVOICE';


export const CHECK_ALL_UPDATE_REQUEST_ALL_OVER_PRINTING = 'CHECK_ALL_UPDATE_REQUEST_ALL_OVER_PRINTING'

export const CHECK_ALL_UPDATE_SUCCESS_COMPACTING_ALL_OVER_PRINTING = 'CHECK_ALL_UPDATE_SUCCESS_COMPACTING_ALL_OVER_PRINTING'

export const CHECK_ALL_UPDATE_FALIURE_COMPACTING_ALL_OVER_PRINTING = '[CHECK_ALL_UPDATE_FALIURE_COMPACTING_ALL_OVER_PRINTING'

export const CLOSE_BTN_POST_REQUEST_ALL_OVER_PRINTING = 'CLOSE_BTN_POST_REQUEST_ALL_OVER_PRINTING'

export const CLOSE_BTN_POST_SUCCESS_COMPACTING_ALL_OVER_PRINTING = 'CLOSE_BTN_POST_SUCCESS_COMPACTING_ALL_OVER_PRINTING'


export const CLOSE_BTN_POST_FALIURE_COMPACTING_ALL_OVER_PRINTING = 'CLOSE_BTN_POST_FALIURE_COMPACTING_ALL_OVER_PRINTING'

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';

export const NAVIGATE_ALL_OVER_PRINTING_PRINT = 'NAVIGATE_ALL_OVER_PRINTING_PRINT';